import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LCFormComponent } from './lc-forms.component';
import { LCElementComponent } from './lc-element.component';
import { LCFormService } from './lc-forms.service';
export class LCFormsModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule, ReactiveFormsModule],
    declarations: [LCFormComponent, LCElementComponent],
    exports: [LCFormComponent, LCElementComponent],
    providers: [LCFormService]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function LCFormsModule_tsickle_Closure_declarations() {
/** @type {?} */
LCFormsModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
LCFormsModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
